import React, { useState, useEffect } from "react";
import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import { navigate } from 'gatsby';
import 'react-phone-input-2/lib/style.css';
import axios from 'axios';

import { useFormik } from 'formik';
import PhoneInput from 'react-phone-input-2';
import { object, string } from "yup";
import LazyLoad from 'react-lazy-load'

// const { useFormik } = React.lazy(() => import('formik'))
// const PhoneInput = React.lazy(() => import('react-phone-input-2'))
// const { object, string } = React.lazy(() => import('yup'))

const RequestQuote = () => {

    const [curCity, setCity] = useState();
    const [curCountry, setCountry] = useState();
    const [curRegion, setRegion] = useState();
    const [curZip, setZip] = useState();
    const [successMsg, setsuccessMsg] = useState("");
    const [disable, setDisable] = React.useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const key = 'contact_page_form_scan_n_thru';
    const company_id = "60e2f262bae0d2cc386c1de4";
    const source = "60e4086c46dcd0d0eecebe8d";
    const pipeline = "5e009a3150476053816421e9";
    const apikey = '663ca52af9a52312606cbe56';
    const publickey = 'dfbc44f68977568186f53347b847953d100f92c3';
    const signature = 'a98012fbee01467f8bada975ea6358cce239e27f';
    const address = {
        countryCode: curCountry,
        regionName: curRegion,
        city: curCity,
        zip: curZip,
    }
    const userCountry = address.countryCode?.toLowerCase();
    const formUrl = typeof window !== 'undefined' ? window.location.href : null;

    // get prevoius url from any page and get here
    const previousUrl = typeof window !== 'undefined' ? sessionStorage.getItem('previous_url') : null;

    useEffect(() => {

        axios.get('https://ipinfo.io/json').then((result) => {
            setCountry(result.data['country']);
            setRegion(result.data['region']);
            setZip(result.data['postal']);
            setCity(result.data['city']);
        })
    }, []);

    const validationSchema = object().shape({
        full_name: string().required('Name is required').matches(/^[aA-zZ\s]+$/, "Name is invalid"),
        email: string().required('Email is required').email('Email is invalid'),
        phone_no: string().required("Phone number is required").min(4, "Mobile Number required"),
        company_name: string().required('Company name is required'),
        description: string().required('Message is required'),
        // reason: string().required('Product is required'),
        // industry: string().required('Industry is required'),
        // license: string().required('Please select an option from the dropdown menu.')
    });

    const formikLogin = useFormik({
        initialValues: {
            full_name: "",
            email: "",
            phone_no: "",
            company_name: '',
            skype_id: "",
            reason: "" || "Scan ‘N’ Thru",
            industry: "",
            license: '',
            description: "",
        },
        validationSchema: validationSchema,
        onSubmit: async (values, { resetForm }) => {

            const social_info = {
                skype_id: values.skype_id,
            }

            const additional_info = {
                url: formUrl,
                product: values.reason || "Scan ‘N’ Thru",
                previousUrl: previousUrl || "No",
            }

            const hubpost_properties = {
                // industry: values.industry,
                product_interested_in: values.reason || "Scan ‘N’ Thru",
                // license_status: values.license
                previousUrl: previousUrl || "No",
            }

            setDisable(true);
            setIsLoading(true);

            try {
                // let result = await fetch("https://q0j7z0lfs5.execute-api.us-west-2.amazonaws.com/lambda-create-deal", {
                //     method: "POST",
                //     body: JSON.stringify({ full_name: values.full_name, email: values.email, phone_no: values.phone_no, company_name: values.company_name, description: values.description + ' (Product interested in : ' + (values.reason || "Scan ‘N’ Thru") + ', Number of sites : ' + values.industry + ', Monthly transaction volume : ' + values.license + ')', social_info, key, address, additional_info, company_id, source, pipeline, hubpost_properties, apikey, publickey, signature }),
                //     headers: { 'Content-Type': 'application/json' },
                // });

                let result_pms_crm_lead = await fetch("https://9cdbp7k459.execute-api.us-west-2.amazonaws.com/default/pms_crm_lead", {
                    method: "POST",
                    body: JSON.stringify({ full_name: values.full_name, email: values.email, phone_no: values.phone_no, company_name: values.company_name, description: values.description + ' (Product interested in : ' + (values.reason || "Scan ‘N’ Thru") + ', Number of sites : ' + values.industry + ', Monthly transaction volume : ' + values.license + ')', social_info, key, address, additional_info, company_id, source, pipeline, hubpost_properties, apikey, publickey, signature }),
                    headers: { 'Content-Type': 'application/json' },
                });

                let result_hubspot_lead = await fetch("https://qtjs8w6uzg.execute-api.us-west-2.amazonaws.com/default/hubspot_lead", {
                    method: "POST",
                    body: JSON.stringify({ full_name: values.full_name, email: values.email, phone_no: values.phone_no, company_name: values.company_name, description: values.description + ' (Product interested in : ' + (values.reason || "Scan ‘N’ Thru") + ', Number of sites : ' + values.industry + ', Monthly transaction volume : ' + values.license + ')', social_info, key, address, additional_info, company_id, source, pipeline, hubpost_properties, apikey, publickey, signature }),
                    headers: { 'Content-Type': 'application/json' },
                });

                result_pms_crm_lead = await result_pms_crm_lead.json();
                result_hubspot_lead = await result_hubspot_lead.json();

                if (result_pms_crm_lead.status === 200 || result_hubspot_lead.status === 200) {

                    // setsuccessMsg("Thank you for choosing DigiPay.Guru..!");
                    setsuccessMsg(false);
                    setDisable(false);
                    setIsLoading(false);
                    navigate('/thankyou');
                    resetForm();

                } else {

                    setDisable(false);
                    setIsLoading(false);
                    setsuccessMsg("Some error occured else");

                }

            } catch (err) {

                setDisable(false);
                setIsLoading(false);
                setsuccessMsg("Some error occured catch");

            }

        }

    });

    const { errors, touched } = formikLogin;

    return (
        <>
            <section className="footer-form-section section">
                <Container className="py-5">
                    <Row className="justify-content-between align-items-center g-4">
                        <Col lg={5}>
                            <div className="section-title mb-lg-5">
                                <p className="heading text-white mb-5 fw-semibold h2 font-size-64">Ask us anything or just say hi...</p>
                                <p className="text-white opacity-85 lead">Fill all your details in the form and one of our business consultant will get in touch you within 24 hours.</p>
                            </div>
                        </Col>
                        <Col lg={6}>
                            <h2 className="heading text-white mb-4-lg fw-semibold">Get a live demo</h2>
                            <LazyLoad offset={300}>
                                <Form>
                                    <Row md={2} xs={1}>
                                        <Form.Group as={Col} className={errors.full_name && touched.full_name ? "mb-4 was-validated" : "mb-4"}>
                                            <Form.Control
                                                type="text"
                                                name="full_name"
                                                value={formikLogin.values.full_name}
                                                onChange={formikLogin.handleChange}
                                                onBlur={formikLogin.handleBlur}
                                                placeholder="Enter your full name"
                                                required
                                            />
                                            {/* <p className="form-text text-danger mt-2 mb-0 font-size-14 text-uppercase0">
                                                {errors.full_name && touched.full_name ? errors.full_name : null}
                                            </p> */}
                                        </Form.Group>
                                        <Form.Group as={Col} className={errors.email && touched.email ? "mb-4 was-validated" : "mb-4"}>
                                            <Form.Control
                                                type="email"
                                                name="email"
                                                value={formikLogin.values.email}
                                                onChange={formikLogin.handleChange}
                                                onBlur={formikLogin.handleBlur}
                                                placeholder="Provide your email address"
                                                required
                                            />
                                            {/* <p className="form-text text-danger mt-2 mb-0 font-size-14 text-uppercase0">
                                                {errors.email && touched.email ? errors.email : null}
                                            </p> */}
                                        </Form.Group>
                                        <Form.Group as={Col} className={errors.phone_no && touched.phone_no ? "mb-4 was-validated" : "mb-4"}>
                                            <PhoneInput
                                                inputProps={{ name: "phone_no" }}
                                                inputClass="form-control-phone"
                                                containerClass="country-phone"
                                                onChange={(e) => formikLogin.setFieldValue("phone_no", e)}
                                                onBlur={formikLogin.handleBlur}
                                                value={formikLogin.values.phone_no}
                                                country={userCountry ? userCountry : 'us'}
                                                countryCodeEditable={true}
                                                enableSearch={true}
                                                disableSearchIcon={true}
                                            />
                                            {/* <p className="form-text text-danger mt-2 mb-0 font-size-14 text-uppercase0">
                                                {errors.phone_no && touched.phone_no ? errors.phone_no : null}
                                            </p> */}
                                        </Form.Group>
                                        <Form.Group as={Col} className={errors.company_name && touched.company_name ? "mb-4 was-validated" : "mb-4"}>
                                            <Form.Control
                                                type='text'
                                                name='company_name'
                                                value={formikLogin.values.company_name}
                                                onChange={formikLogin.handleChange}
                                                onBlur={formikLogin.handleBlur}
                                                placeholder='Provide your company name'
                                                required
                                            />
                                            {/* <p className='form-text text-danger mt-2 mb-0 font-size-14 text-uppercase0'>
                                                {errors.company_name && touched.company_name
                                                    ? errors.company_name
                                                    : null}
                                            </p> */}

                                        </Form.Group>
                                        <Form.Group as={Col} className={errors.industry && touched.industry ? "mb-4 was-validated" : "mb-4"}>
                                            <Form.Select name="industry"
                                                aria-label="Industry"
                                                value={formikLogin.values.industry}
                                                onChange={formikLogin.handleChange}
                                                onBlur={formikLogin.handleBlur}
                                            // required
                                            >
                                                <option value=''>Number of sites</option>
                                                <option value='1 to 10'>1 to 10</option>
                                                <option value='10 to 50'>10 to 50</option>
                                                <option value='50 to 100'>50 to 100</option>
                                                <option value='100 to 300'>100 to 300</option>
                                                <option value='More than 300'>More than 300</option>
                                            </Form.Select>
                                            {/* <p className="form-text text-danger mt-2 mb-0 font-size-14 text-uppercase0">
                                                {errors.industry && touched.industry ? errors.industry : null}
                                            </p> */}
                                        </Form.Group>
                                        <Form.Group className={errors.license && touched.license ? "mb-4 was-validated" : "mb-4"}>
                                            <Form.Select
                                                aria-label="License"
                                                name='license'
                                                value={formikLogin.values.license}
                                                onChange={formikLogin.handleChange}
                                                onBlur={formikLogin.handleBlur}
                                            // required
                                            >
                                                <option value=''>Monthly transaction volume</option>
                                                <option value='Less than 1,000'>Less than 1,000</option>
                                                <option value='1,000 to 5,000'>1,000 to 5,000</option>
                                                <option value='5,000 to 10,000'>5,000 to 10,000</option>
                                                <option value='10,000 to 50,000'>10,000 to 50,000</option>
                                                <option value='More than 50,000'>More than 50,000</option>
                                            </Form.Select>
                                            {/* <p className='form-text text-danger mt-2 mb-0 font-size-14 text-uppercase0'>
                                            {errors.license && touched.license
                                                ? errors.license
                                                : null}
                                        </p> */}
                                        </Form.Group>
                                        {/* <Form.Group as={Col} className='mb-4'>
                                            <Form.Control
                                                type="text"
                                                name="skype_id"
                                                value={formikLogin.values.skype_id}
                                                onChange={formikLogin.handleChange}
                                                onBlur={formikLogin.handleBlur}
                                                placeholder="Enter your skype id"
                                            />
                                        </Form.Group> */}

                                        {/* <Form.Group as={Col} className={errors.reason && touched.reason ? "mb-4 was-validated" : "mb-4"}>
                                            <Form.Select name="reason"
                                                aria-label="Reason"
                                                value={formikLogin.values.reason}
                                                onChange={formikLogin.handleChange}
                                                onBlur={formikLogin.handleBlur} required>
                                                <option value="">Product interested in</option>
                                                <option value="Mobile Money / eWallet Development">Mobile Money / eWallet Development</option>
                                                <option value="Agency Banking">Agency Banking</option>
                                                <option value="Cross border Payment system">Cross border Payment system</option>
                                                <option value="Merchant Solution">Merchant Solution</option>
                                                <option value='Prepaid Cards'>Prepaid Cards</option>
                                                <option value='eKYC Solution'>eKYC Solution</option>
                                                <option value='Scan & Thru'>Scan & Thru</option>
                                                <option value="Other">Other</option>
                                            </Form.Select>
                                            <p className="form-text text-danger mt-2 mb-0 font-size-14 text-uppercase0">
                                                {errors.reason && touched.reason ? errors.reason : null}
                                            </p>
                                        </Form.Group> */}
                                    </Row>
                                    <Form.Group className={errors.description && touched.description ? "mb-4 was-validated" : "mb-4"}>
                                        <Form.Control
                                            as="textarea"
                                            name="description"
                                            value={formikLogin.description}
                                            onChange={formikLogin.handleChange}
                                            onBlur={formikLogin.handleBlur}
                                            placeholder="Kindly describe your project idea"
                                            rows={3}
                                            required
                                        />
                                        {/* <p className="form-text text-danger mt-2 mb-0 font-size-14 text-uppercase0">
                                            {errors.description && touched.description ? errors.description : null}
                                        </p> */}
                                    </Form.Group>
                                    <div className="form-action text-end">
                                        <Button type="button" onClick={() => formikLogin.handleSubmit()} disabled={disable} variant="" size="lg" className="btn-primary-theme mt-2">
                                            <span>{isLoading ? 'Sending...' : 'Send now'}</span>
                                        </Button>
                                    </div>
                                    {successMsg ? <div className="alert alert-success mt-4"> {successMsg} </div> : null}
                                </Form>
                            </LazyLoad>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
}

export default RequestQuote
